import Actions from './Actions';
import Body from './Body';
import CloseButton from './CloseButton';
import Content, { type ContentProps } from './Content';
import { Form } from './Form';
import Header from './Header';
import ResourceGuard, { type ResourceGuardProps } from './ResourceGuard';
import Root, {
  type BaseDialogProps,
  type ControlledDialogProps,
  type RootHandlers,
  type RootProps,
} from './Root';
import SubmitError from './SubmitError';
import Subtitle from './Subtitle';
import Title from './Title';
import Trigger from './Trigger';
import TriggerButtonIcon, {
  type TriggerButtonIconProps,
} from './TriggerButtonIcon';

export type { RootHandlers as DialogRootHandlers };
export type { RootProps as DialogRootProps };
export type { ControlledDialogProps as DialogControlledProps };
export type { BaseDialogProps as DialogBaseProps };
export type { ContentProps as DialogContentProps };
export type { TriggerButtonIconProps };
export type { ResourceGuardProps as DialogResourceGuardProps };
export { asDialogSlot, type DialogSlot } from './composition';
export type { DialogSubmitEvent } from './useDialogForm';
export { useDialogContext } from './context';
export { useDialogPopper } from './useDialogPopper';
export { useDialogPortalContainer } from './useDialogPortalContainer';

export const DialogComposite = {
  Root,
  Content,
  Form,
  Header,
  Title,
  Subtitle,
  /**
   * @deprecated The Encore dialog molecules own their own dismissal (footer
   * actions, the backdrop, Escape, and the full-screen molecule's built-in
   * close button), so a `CloseButton` placed in the `Header` renders nothing
   * and its `onClick` never fires. Remove it when migrating a dialog to the
   * Encore `DialogComposite`. (The MUI `DialogCompositeMui.CloseButton` still
   * renders it and is not deprecated.)
   */
  CloseButton,
  Body,
  Actions,
  ResourceGuard,
  Trigger,
  TriggerButtonIcon,
  SubmitError,
};
